<div class="d-flex flex-column h-100 w-100 position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary flex-grow-1" id="modal-title" *ngIf="!this.depId" title="{{ jobFileName }}">
      File : {{ jobFileName | shortenString:trimIndex }}
    </h4>
    <h4 class="modal-title synchpc-primary flex-grow-1" id="modal-title" *ngIf="this.depId"
      title="Status of {{ this.depName }}">
      {{ depName }} Deployment Status
    </h4>
    <div class="h-100 themeIcon" (click)="isDarkMode = !isDarkMode" [ngClass]="{'lightIcon':isDarkMode }">
      @if(isDarkMode) {
        <mat-icon name="material-symbols-outlined" triggers="hover" ngbTooltip="Switch to light theme" container="body">light_mode</mat-icon>
      } @else {
        <mat-icon name="material-symbols-outlined" triggers="hover" ngbTooltip="Switch to dark theme" container="body">dark_mode</mat-icon>
      }
    </div>
    <div class="fileSearch" *ngIf="!toggleDialog">
      <div class="inputAndResults">
        <input class="searchInput" type="text" placeholder="Search" value="{{ searchTerm }}"
          (input)="searchKeyword($event.target.value)" />
        <label class="searchResults" for="">{{ currentWordIndex }}/{{ totalWordCount }}</label>
      </div>
      <div class="searchIcons">
        <button class="isCaseSensitive" (click)="makeCaseSensitive()" title="{{ isSensitiveTitle }}" [ngStyle]="
            isSensitive ? { color: 'var(--s-primary-color)', 'font-weight': '600' } : {}
          ">
          Aa
        </button>
        <span title="Previous" [class.iconDisabled]="totalWordCount == 0" (click)="findPrevious()"
          class="bi bi-arrow-up-short"></span>
        <span title="Next" [class.iconDisabled]="totalWordCount == 0" (click)="findNext()"
          class="bi bi-arrow-down-short"></span>
        <span title="Clear Search" (click)="clearSearch()" class="bi bi-x-lg text-danger"></span>
      </div>
    </div>
  </div>
  <mat-dialog-content class="mat-typography fileContent position-relative" [ngClass]="{'whiteTheme': !isDarkMode}">

    <!--!Image File preview  -->
    <div class="imagePreview"
    *ngIf="FileTypes.checkFileType(path) == FileTypes.ImageFile" 
    style="position: relative; height: 100%; width: 100%; overflow: hidden;"
    >
    <div
        #zoomContainer
        class="zoom-container"
        (wheel)="onMouseWheel($event)"
        (mousedown)="startDrag($event)"
        (mouseup)="stopDrag()"
        (mouseleave)="stopDrag()"
        (mousemove)="onDrag($event)"
        style="overflow: hidden; position: absolute; transition: transform 0.2s ease; cursor: grab;"
       
      >
      
      <img 
      [src]="sanitizedImageUrl" 
          alt="image preview" 
          style="position: absolute; width: auto; max-height: 98%; user-select: none;" 
          draggable="false"
          [ngStyle]="{
            transform: 'translate(calc(-50% + ' + offsetX + 'px), calc(-50% + ' + offsetY + 'px)) scale(' + zoomScale + ')',
            top: '50%',
            left: '50%'
          }"
        >
        
      </div>
      
      <div *ngIf="!sanitizedImageUrl && showInvalidMessage" style="color: red;">Image data not available</div>
    </div>
    
    
    <div *ngIf="FileTypes.checkFileType(path) == FileTypes.ImageFile"  class="zoom-slider-wrapper mb-1 d-flex justify-content-center align-items-center" style="height: 30px;">
      <input 
      type="range" 
      min="0.5" 
      max="3" 
      step="0.1" 
      [(ngModel)]="zoomScale" 
      class="zoom-slider"
      />
      <span class="" [ngClass]="{'zoom-label-dark': !isDarkMode, 'zoom-label' : isDarkMode}">{{ zoomScale.toFixed(1) }}x</span>
      <button 
      class="reset-zoom actionBtn" 
      (click)="resetZoom()"
      [ngStyle]="{ visibility: zoomScale !== 1 || offsetX !== 0 || offsetY !== 0 ? 'visible' : 'hidden' }"
      >
      <i class="bi bi-x-circle"></i>
    </button>
  </div>
  <!--!Image File preview Ends here -->
  
  
  <!--!Video File preview -->
  <div *ngIf="FileTypes.checkFileType(path) == FileTypes.VideoFile" class="videoPreview d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;">
    <video *ngIf="sanitizedVideoUrl" width="auto" height="98%" controls>
      <source [src]="sanitizedVideoUrl">
            Your browser does not support the video tag.
    </video>
    <div *ngIf="!sanitizedVideoUrl && showInvalidMessage" style="color: red;">Video data not available</div>
  </div>
    <!--!Video File preview Ends here -->
    
    <!--!Model Viewer File preview -->
    <div *ngIf="FileTypes.checkFileType(path) == FileTypes.ModelViewerFile" class="modelViewerPreview d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;">
      <model-viewer
        *ngIf="sanitizedModelViewerUrl"
        [ar-modes]="['webxr', 'scene-viewer']"
        [src]="sanitizedModelViewerUrl"
        camera-controls
        alt="3D model"
        auto-rotate
        ar
        style="width: 100%; height: 100%;"
      ></model-viewer>
      <div *ngIf="!sanitizedModelViewerUrl && showInvalidMessage" style="color: red;">Model View data not available</div>
    </div>
      <!--!Model Viewer File preview Ends here -->
      
      <!--!Text File preview Ends here -->
      <div #scrollMe *ngIf="FileTypes.checkFileType(path) == FileTypes.TxtFile">
        <div>
          <p *ngIf="contentEditable == false && toShowPipe == true" readonly
          [innerHTML]="jobOutput | highlight: searchTerm:regexCode"></p>
          <p #editedFile contenteditable="true" *ngIf="contentEditable == true"
          [innerHTML]="jobOutput | highlight: searchTerm:regexCode"></p>
        </div>
      </div>
      <!--!Text File preview Ends here -->
      
    <!--!Audio File preview  (Not fully implemented or tested) -->
    <div *ngIf="FileTypes.checkFileType(path) === FileTypes.AudioFile" class="audioPreview d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;">
      <audio *ngIf="sanitizedAudioUrl" controls>
        <source [src]="sanitizedAudioUrl" [type]="FileTypes.getMimeTypeForBlob(path, env.envVariables.TextFileExtension)">
        Your browser does not support the audio element.
      </audio>
      <div *ngIf="!sanitizedAudioUrl && showInvalidMessage" style="color: red;">
        Audio data not available
      </div>
    </div>
    <!--!Audio File preview Ends here -->

    <ngx-spinner bdColor="rgba(0,0,0,0)" [name]="path" size="default" zIndex="999" [color]="isDarkMode ? 'white' : 'black'" type="ball-spin" [fullScreen]="false"></ngx-spinner>
  </mat-dialog-content>
  
  <div *ngIf="FileTypes.checkFileType(path) == FileTypes.TxtFile" class="modal-footer justify-content-center">
    @if(totalPages != -1 && currentPage != -1){
      <ngb-pagination  [collectionSize]="totalPages" [pageSize]="1" [(page)]="currentPage" (pageChange)="handlePageEvent($event)" class="me-2" [maxSize]="5" [rotate]="true" />   
    }
    @if(!contentEditable){
      <button title="Refresh Job Output" type="button" (click)="manualRefresh()"
        [disabled]="isAutoRefreshEnabled" class="default-btn">
        Manual Refresh
      </button>
      <button title="Job Output will be refresh every 7 seconds" type="button" (click)="autoRefresh()"
        [disabled]="isAutoRefreshEnabled" class="default-btn">
        Auto Refresh
      </button>
      <button *ngIf="isAutoRefreshEnabled" title="Pause Auto Refresh" (click)="pause()" [disabled]="disabled" class="default-btn">
        Pause
      </button>
    }
  </div>
</div>